import { z } from '../zod.js';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';

export const GetFormPageInputValidationSchema = z.object({
  pageId: ObjectIdStringValidationSchema.meta({
    description:
      'The ID of the form to retrieve. You can get this from `create_form`, the dashboard, or another Checkout Page API response.',
  }),
});
